import React, { useEffect, useState } from 'react'
import classes from './home.module.css'
import { List, Space, Image } from 'antd'
import { useNewsListQuery } from '../store/ReactWebSiteApi'
import dayjs from 'dayjs'
import WebNewsCheck from './WebNewsCheck'
import { ClockCircleOutlined, EyeOutlined } from '@ant-design/icons'
import WebMain from './WebMain'

function WebNews() {
    const { data, isSuccess } = useNewsListQuery({ en_e_id: '218' })
    const [list, setList] = useState()
    useEffect(() => {
        if (isSuccess) {
            if (data.Status === 'success') {
                const newArr = data.Result.map((item) => {
                    const { en_id: key, en_name, en_num, en_content, en_ctime, en_state, en_type_name, en_image } = item
                    return { ...item, key, en_name, en_num, en_content, en_ctime, en_state, en_type_name, en_image }
                })
                const sortArr = newArr.sort((a, b) => {
                    const aTime = new Date(a.en_ctime).getTime()
                    const bTime = new Date(b.en_ctime).getTime()
                    return bTime - aTime
                })
                setList(sortArr)
            } else {
                setList('')
            }
        }
    }, [data, isSuccess])

    return (
        <WebMain selectedKeys="news">
            <div style={{ backgroundColor: '#fff', padding: '16px 12px 32px' }}>
                <div className={classes.newsMain}>
                    <List
                        size="large"
                        itemLayout="vertical"
                        dataSource={list}
                        renderItem={(item) => {
                            if (item.en_state === '2') {
                                return (
                                    <List.Item key={item.key} style={{ padding: '16px 0' }}>
                                        <List.Item.Meta
                                            avatar={
                                                <Image
                                                    src={`/api/assets/images/application/${item.en_image}`}
                                                    shape="square"
                                                    width="100%"
                                                    style={{ maxWidth: 120, borderRadius: 8 }}
                                                />
                                            }
                                            title={
                                                <WebNewsCheck
                                                    text={item.en_name}
                                                    en_id={item.key}
                                                    en_image={item.en_image}
                                                />
                                            }
                                            description={
                                                <Space
                                                    wrap
                                                    style={{
                                                        fontSize: 13,
                                                        marginTop: 8,
                                                    }}
                                                >
                                                    <span>
                                                        <ClockCircleOutlined /> {dayjs(item.en_ctime).format('YYYY年MM月DD日')}
                                                    </span>
                                                    <span>
                                                        <EyeOutlined style={{ marginLeft: 8 }} /> {item.en_num}
                                                    </span>
                                                </Space>
                                            }
                                        />
                                    </List.Item>
                                )
                            }
                            return <div key={item.key} />
                        }}
                    />
                </div>
            </div>
        </WebMain>
    )
}

export default WebNews
